export type ButtonVariant = 'primary' | 'pay' | 'secondary' | 'ghost';
export type ButtonSize = 'lg' | 'md' | 'inline';

const base =
  'inline-flex w-full items-center justify-center gap-2 rounded-control font-sans no-underline transition ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ' +
  'disabled:cursor-not-allowed disabled:opacity-50';

const variants: Record<ButtonVariant, string> = {
  /** The one main action of a screen (Continuer, Passer au paiement, Recevoir mon lien…). */
  primary: 'bg-ink font-bold text-paper hover:bg-ink/90 hover:text-paper active:scale-[0.99]',
  /** The payment button only (Payer 55 €). */
  pay: 'bg-accent font-bold text-paper hover:bg-accent-hover hover:text-paper active:scale-[0.99]',
  /** Outlined secondary action (Ajouter une course, Appliquer). */
  secondary:
    'border-[1.5px] border-ink bg-paper font-semibold text-ink hover:bg-surface hover:text-ink',
  /** Quiet text action (Plus tard, voir mon profil). */
  ghost: 'bg-transparent font-semibold text-ink-muted hover:text-ink',
};

const sizes: Record<ButtonSize, string> = {
  lg: 'h-[54px] px-4 text-[17px]',
  md: 'h-11 px-4 text-[15px]',
  /** Beside a 48 px input, same height (Appliquer next to the promo code). */
  inline: 'h-12 px-4 text-[15px]',
};

/** Class names for a button look, for `<Link>` or `<a>` CTAs. */
export function buttonClasses(variant: ButtonVariant = 'primary', size: ButtonSize = 'lg') {
  return `${base} ${variants[variant]} ${sizes[size]}`;
}
